import useBasketState from '../../use/useBasketState';

const basketState = useBasketState();
export default {
  state: () => ({
    data: {},
  }),
  mutations: {
    'basket/setState'(state, payload) {
      state.data = { ...payload };
    },
    'basket/changeActiveKits'(state, payload) {
      state.data = {
        ...state.data,
        kitsTabs: state.data.kitsTabs.map((el, key) => ({
          ...el,
          active: payload === key,
        })),
      };
    },
  },
  actions: {
    async 'basket/add'({ state: { data }, commit, getters }, { id, count = 1 }) {
      try {
        commit('global/loaderStart');
        const { path, 'params-example-data': params } = data.routes.add;
        const requestParams = {
          action: params.action,
          id,
          count,
        };

        const { status, data: responseData } = await axios.post(path, requestParams);
        if (status !== 200) {
          throw `add to basket bad response status ${status}`;
        }

        commit('basket/setState', responseData);
        return responseData;
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'basket/remove'({ state: { data }, commit, dispatch, rootState }, payload) {
      try {
        const { path, 'params-example-data': params } = data.routes.remove;
        const requestParams = {
          id: payload.id,
          basket_Id: payload.basketId,
          action: params.action,
        };
        const { status, data: responseData } = await axios.post(path, requestParams);

        if (status !== 200 || responseData.error) {
          throw `Bad request delete product from basket status: ${status} \n ${responseData.error}`;
        }
        if (!responseData.items) basketState.close();

        /**
         * https://jira.aniart.com.ua/browse/SOVA2-286
         * Редирект на главную после очищения корзины от всех товаров в чекауте
         */
        if (!responseData.items && responseData.redirect)
          window.location.href = responseData.redirect;

        commit('basket/setState', responseData);
      } catch (err) {
        console.error(err);
      }
    },
    async 'basket/update'({ state: { data }, commit, dispatch, rootState }, { id, count = 1 }) {
      try {
        const { path, 'params-example-data': params } = data.routes.update;
        const requestParams = {
          action: params.action,
          id,
          count,
        };

        const { status, data: responseData } = await axios.post(path, requestParams);
        if (status !== 200) {
          throw `add to basket bad response status ${status}`;
        }

        commit('basket/setState', responseData);
      } catch (err) {
        console.error(err);
      }
    },
    async 'basket/createOrderByOneClick'({ state: { data }, dispatch }, requestParams) {
      try {
        const { path, 'params-example-data': params } = data?.routes?.buyOneClick;

        const ajaxParams = {
          ...requestParams,
          action: params.action,
          LANGUAGE_ID: params.LANGUAGE_ID,
        };

        const { status, data: responseData } = await axios.post(path, ajaxParams);
        if (status !== 200) {
          throw `create order one click bad response status ${status}`;
        }
        await dispatch('basket/getData');

        return responseData;
      } catch (err) {
        console.error(err);
      }
    },
    async 'basket/changeSKU'({ state, commit }, payload) {
      try {
        commit('global/loaderStart');
        const {
          path,
          'params-example-data': { action },
        } = state.data.routes.changeSku;
        const {
          status,
          data: { product },
        } = await axios.get(payload.size.detailPage, { params: { api: 'y' } });

        if (status !== 200) throw new Error(`bad request response: ${status}`);

        const newId = product?.offer?.id ?? product.id;

        if (newId === payload.id) {
          return;
        }

        const response = await axios.post(path, {
          action,
          newId,
          oldId: payload.id,
        });

        if (response.status === 200) {
          commit('basket/setState', response.data);
        }

        commit('global/loaderStop');
        return product;
      } catch (err) {
        console.error(err);
      }
    },
    async 'basket/getData'({ state, commit }) {
      try {
        commit('global/loaderStart');

        const { path, action } = state.data.routes?.getBasket;
        const { status, data } = await axios.post(path, { action });

        if (status === 200) {
          commit('basket/setState', data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'basket/setClubCard'({ state, dispatch }) {
      try {
        const { status, data: responseData } = await axios.post('/ajax/', {
          action: 'setClubCard',
        });
        // situations appears when user has more than 1 clubcard
        if (
          responseData?.clubCard?.length > 0 &&
          !state?.data?.price?.clubCard &&
          state?.data?.count > 0
        ) {
          await dispatch('basket/getData');
        }
        // if (status !== 200) throw `Bad request response status: ${status}`;
      } catch (err) {
        // console.error(err);
      }
    },
    async 'basket/setCoupon'({ state, commit }, payload) {
      commit('global/loaderStart');
      const {
        path,
        'params-example-data': { action },
      } = state.data.routes?.setCoupon;
      const props = {
        coupon: payload,
        action,
      };

      const { data } = await axios.post(path, props);

      if (!data.error) {
        commit('basket/setState', data);
      }

      commit('global/loaderStop');
      return state.data;
    },
    async 'basket/deleteCoupon'({ state, commit }, payload) {
      commit('global/loaderStart');
      const {
        path,
        'params-example-data': { action },
      } = state.data.routes?.delCoupon;
      const props = {
        coupon: payload,
        action,
      };

      const { data } = await axios.post(path, props);
      commit('basket/setState', data);
      commit('global/loaderStop');
      return data;
    },
    async 'basket/setCertificate'({ state, commit }, payload) {
      try {
        commit('global/loaderStart');
        const {
          path,
          'params-example-data': { action },
        } = state.data.routes?.setCertificate;
        const props = {
          certificate: payload,
          action,
        };

        const { data, status } = await axios.post(path, props);

        if (status !== 200) {
          throw `Something went wrong status ${status}`;
        } else if (!data.error) {
          commit('basket/setState', data);
        }

        return data;
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'basket/deleteCertificate'({ state, commit }, payload) {
      try {
        commit('global/loaderStart');

        const {
          path,
          'params-example-data': { action },
        } = state.data.routes?.delCertificate;
        const props = {
          certificate: payload,
          action,
        };

        const { data, status } = await axios.post(path, props);

        if (status !== 200) {
          throw `Something went wrong status ${status}`;
        }

        commit('basket/setState', data);
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    /** remove IPost order * */
    async 'basket/getBackBasketItems'({ state, commit, dispatch }) {
      try {
        commit('global/loaderStart');
        const IPostFieldsString = window.sessionStorage.getItem('IPostFields');
        if (IPostFieldsString && !location.pathname.includes('/personal/order/make/')) {
          await axios.post('/ajax/', {
            action: 'getBackBasketItems',
          });
          window.sessionStorage.removeItem('IPostFields');
          await dispatch('basket/getData');
        }

        const createCreditOrder = sessionStorage.getItem('createCreditOrder');
        if (createCreditOrder && !location.pathname.includes('/personal/order/make/')) {
          await axios.post('/ajax/', {
            action: 'getBackBasketItems',
          });
          window.sessionStorage.removeItem('createCreditOrder');
          await dispatch('basket/getData');
        }

        const engraving = sessionStorage.getItem('engraving');
        if (engraving && !location.pathname.includes('/personal/order/make/')) {
          await axios.post('/ajax/', {
            action: 'getBackBasketItems',
          });
          window.sessionStorage.removeItem('engraving');
          await dispatch('basket/getData');
        }
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    /** box * */
    async 'basket/addBox'({ state: { data }, commit, getters }, payload) {
      try {
        commit('global/loaderStart');
        const { path, 'params-example-data': params } = data.routes.addBox;

        const requestParams = {
          action: params.action,
          ...payload,
        };

        const { status, data: responseData } = await axios.post(path, requestParams);
        if (status !== 200) {
          throw `add to basket bad response status ${status}`;
        }

        commit('basket/setState', responseData);
        return responseData;
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'basket/removeBox'({ state: { data }, commit, getters }, payload) {
      try {
        commit('global/loaderStart');
        const { path, 'params-example-data': params } = data.routes.removeBox;

        const requestParams = {
          action: params.action,
          ...payload,
        };

        const { status, data: responseData } = await axios.post(path, requestParams);
        if (status !== 200) {
          throw `add to basket bad response status ${status}`;
        }

        commit('basket/setState', responseData);
        return responseData;
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
  },
  getters: {
    'basket/inBasket':
      ({ data: { items } }) =>
      (id) => {
        try {
          if (Array.isArray(items)) {
            return !!items.find((el) => el?.offer?.id == id || el?.id == id);
          }
          return false;
        } catch (err) {
          console.error(err);
          return false;
        }
      },
    'basket/getProductById':
      ({ data: { items } }) =>
      (id) => {
        try {
          if (Array.isArray(items)) {
            return items.find((el) => el.offer.id == id || el.id == id);
          }
          return false;
        } catch (err) {
          console.error(err);
          return false;
        }
      },
    'basket/getBasketCoupon': ({ data: { price } }) => {
      try {
        if (price?.coupons) {
          return {
            name: Object.keys(price.coupons)[0],
            value: Object.values(price.coupons)[0],
          };
        }
        return null;
      } catch (err) {
        console.error(err);
        return false;
      }
    },
    'basket/getSovaClub': ({ data: { price } }) => {
      try {
        if (price?.clubCard) {
          return {
            name: Object.keys(price.clubCard)[0],
            value: Object.values(price.clubCard)[0],
          };
        }
        return null;
      } catch (err) {
        console.error(err);
        return false;
      }
    },
  },
};
